// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ViewMore_episodesContainer__s8mxL {
  width: 100%;
  max-width: 1000px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 10px 0;
  background-color: #1a1a1a;
}
.ViewMore_episodeTitle__NEIKS{
  font-size: 20px;
  color: white;
  max-width: 95%;
}

.ViewMore_episodeCard__3\\+xsb {
  display: flex;
  flex-direction: column;
  background-color: #1a1a1a;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  padding: 10px 10px 15px;
  border-radius: 0;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.ViewMore_episodeCard__3\\+xsb:hover {
  background-color: #1a1a1a;
}

.ViewMore_episodeCard__3\\+xsb.ViewMore_playing__cC6E8 {
  background-color: #1e1e1e;
}

.ViewMore_episodeDetails__aqFhl {
  display: flex;
  align-items: center;
  gap: 15px;
}

.ViewMore_episodeImage__Y7xMX {
  position: relative;
  width: 100px;
  height: 100px;
  overflow: hidden;
  border-radius: 6px;
  flex-shrink: 0;
}

.ViewMore_episodeImage__Y7xMX img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.ViewMore_playIcon__TTldl {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.2s ease;
}

.ViewMore_episodeCard__3\\+xsb:hover .ViewMore_playIcon__TTldl {
  opacity: 1;
}

.ViewMore_playingIndicator__KvcpL {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
}

.ViewMore_playingIndicator__KvcpL .ViewMore_bar__PbW6\\+ {
  width: 4px;
  height: 20px;
  background-color: #ff4b4b;
  border-radius: 2px;
  animation: ViewMore_soundBars__15DgY 1.2s infinite ease-in-out;
}

.ViewMore_playingIndicator__KvcpL .ViewMore_bar__PbW6\\+:nth-child(1) {
  animation-delay: 0s;
}

.ViewMore_playingIndicator__KvcpL .ViewMore_bar__PbW6\\+:nth-child(2) {
  animation-delay: 0.3s;
  height: 30px;
}

.ViewMore_playingIndicator__KvcpL .ViewMore_bar__PbW6\\+:nth-child(3) {
  animation-delay: 0.6s;
}

@keyframes ViewMore_soundBars__15DgY {
  0% { height: 15px; }
  50% { height: 30px; }
  100% { height: 15px; }
}

.ViewMore_episodeInfo__nTNDc {
  display: flex;
  flex-direction: column;
  gap: 6px;
  flex: 1 1;
}

.ViewMore_episodeTitle__NEIKS {
  font-size: 18px;
  font-weight: 600;
  color: white;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.ViewMore_arrow__wgpB8 {
  font-size: 24px;
  color: #7e7e7e;
}

.ViewMore_episodeDuration__eSddK {
  font-size: 14px;
  color: #7e7e7e;
}

.ViewMore_listenersCount__TtPE9 {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #ff4b4b;
  font-size: 14px;
  font-weight: 500;
}

.ViewMore_noEpisodes__ggSxB {
  width: 100%;
  padding: 20px;
  text-align: center;
  color: #7e7e7e;
  font-size: 16px;
  background-color: #111111;
  border-radius: 8px;
}

/* Media queries for responsiveness */
@media (max-width: 768px) {
  .ViewMore_episodeImage__Y7xMX {
    width: 80px;
    height: 80px;
  }
  
  .ViewMore_episodeTitle__NEIKS {
    font-size: 16px;
  }
  
  .ViewMore_episodeDuration__eSddK, .ViewMore_listenersCount__TtPE9 {
    font-size: 12px;
  }
}

@media (max-width: 480px) {
  .ViewMore_episodeDetails__aqFhl {
    gap: 10px;
  }
  .ViewMore_episodeTitle__NEIKS{
    font-size: 16px;
  }
  
  .ViewMore_episodeImage__Y7xMX {
    width: 60px;
    height: 60px;
  }
  
  .ViewMore_episodeTitle__NEIKS {
    font-size: 12px;
  }
  
  .ViewMore_episodeDuration__eSddK, .ViewMore_listenersCount__TtPE9 {
    font-size: 8px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Audio/Component/CSS/ViewMore.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,eAAe;EACf,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,iDAAiD;EACjD,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,8DAA8C;AAChD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,KAAK,YAAY,EAAE;EACnB,MAAM,YAAY,EAAE;EACpB,OAAO,YAAY,EAAE;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,qCAAqC;AACrC;EACE;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,SAAS;EACX;EACA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;AACF","sourcesContent":[".episodesContainer {\n  width: 100%;\n  max-width: 1000px;\n  margin: 0 auto;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  padding: 10px 0;\n  background-color: #1a1a1a;\n}\n.episodeTitle{\n  font-size: 20px;\n  color: white;\n  max-width: 95%;\n}\n\n.episodeCard {\n  display: flex;\n  flex-direction: column;\n  background-color: #1a1a1a;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n  padding: 10px 10px 15px;\n  border-radius: 0;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n.episodeCard:hover {\n  background-color: #1a1a1a;\n}\n\n.episodeCard.playing {\n  background-color: #1e1e1e;\n}\n\n.episodeDetails {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n}\n\n.episodeImage {\n  position: relative;\n  width: 100px;\n  height: 100px;\n  overflow: hidden;\n  border-radius: 6px;\n  flex-shrink: 0;\n}\n\n.episodeImage img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.playIcon {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.4);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  opacity: 0;\n  transition: opacity 0.2s ease;\n}\n\n.episodeCard:hover .playIcon {\n  opacity: 1;\n}\n\n.playingIndicator {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.6);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n}\n\n.playingIndicator .bar {\n  width: 4px;\n  height: 20px;\n  background-color: #ff4b4b;\n  border-radius: 2px;\n  animation: soundBars 1.2s infinite ease-in-out;\n}\n\n.playingIndicator .bar:nth-child(1) {\n  animation-delay: 0s;\n}\n\n.playingIndicator .bar:nth-child(2) {\n  animation-delay: 0.3s;\n  height: 30px;\n}\n\n.playingIndicator .bar:nth-child(3) {\n  animation-delay: 0.6s;\n}\n\n@keyframes soundBars {\n  0% { height: 15px; }\n  50% { height: 30px; }\n  100% { height: 15px; }\n}\n\n.episodeInfo {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  flex: 1;\n}\n\n.episodeTitle {\n  font-size: 18px;\n  font-weight: 600;\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.arrow {\n  font-size: 24px;\n  color: #7e7e7e;\n}\n\n.episodeDuration {\n  font-size: 14px;\n  color: #7e7e7e;\n}\n\n.listenersCount {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  color: #ff4b4b;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.noEpisodes {\n  width: 100%;\n  padding: 20px;\n  text-align: center;\n  color: #7e7e7e;\n  font-size: 16px;\n  background-color: #111111;\n  border-radius: 8px;\n}\n\n/* Media queries for responsiveness */\n@media (max-width: 768px) {\n  .episodeImage {\n    width: 80px;\n    height: 80px;\n  }\n  \n  .episodeTitle {\n    font-size: 16px;\n  }\n  \n  .episodeDuration, .listenersCount {\n    font-size: 12px;\n  }\n}\n\n@media (max-width: 480px) {\n  .episodeDetails {\n    gap: 10px;\n  }\n  .episodeTitle{\n    font-size: 16px;\n  }\n  \n  .episodeImage {\n    width: 60px;\n    height: 60px;\n  }\n  \n  .episodeTitle {\n    font-size: 12px;\n  }\n  \n  .episodeDuration, .listenersCount {\n    font-size: 8px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"episodesContainer": `ViewMore_episodesContainer__s8mxL`,
	"episodeTitle": `ViewMore_episodeTitle__NEIKS`,
	"episodeCard": `ViewMore_episodeCard__3+xsb`,
	"playing": `ViewMore_playing__cC6E8`,
	"episodeDetails": `ViewMore_episodeDetails__aqFhl`,
	"episodeImage": `ViewMore_episodeImage__Y7xMX`,
	"playIcon": `ViewMore_playIcon__TTldl`,
	"playingIndicator": `ViewMore_playingIndicator__KvcpL`,
	"bar": `ViewMore_bar__PbW6+`,
	"soundBars": `ViewMore_soundBars__15DgY`,
	"episodeInfo": `ViewMore_episodeInfo__nTNDc`,
	"arrow": `ViewMore_arrow__wgpB8`,
	"episodeDuration": `ViewMore_episodeDuration__eSddK`,
	"listenersCount": `ViewMore_listenersCount__TtPE9`,
	"noEpisodes": `ViewMore_noEpisodes__ggSxB`
};
export default ___CSS_LOADER_EXPORT___;
